// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toast-LinkToast .toast-messageLink {
  display: flex;
  margin-top: 8px;
}
.Toast-LinkToast .toast-messageLink p {
  margin-right: 10px;
}
.Toast-LinkToast .toast-link {
  color: var(--color_primary_500);
  font-weight: bold;
  font-size: 14px;
  text-wrap: nowrap;
}
.Toast-LinkToast.inline {
  display: flex;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Toasts/LinkToast/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,eAAA;AAAJ;AAEI;EACE,kBAAA;AAAN;AAIE;EACE,+BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHJ","sourcesContent":[".Toast-LinkToast {\n  .toast-messageLink {\n    display: flex;\n    margin-top: 8px;\n\n    p {\n      margin-right: 10px;\n    }\n  }\n\n  .toast-link {\n    color: var(--color_primary_500);\n    font-weight: bold;\n    font-size: 14px;\n    text-wrap: nowrap;\n  }\n\n  &.inline {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
